import { CountryCode, getCountries } from "@oysterhr/common"
import { getOrdinalSuffixOfNumber } from "../utils"

export enum TabsEnum {
  GENERAL = "general",
  CONTACTS = "contacts",
  HIRING_ONBOARDING = "hiringOnboarding",
  FINANCE = "finance",
  POLICIES_TOOLS = "policiesTools",
  KLEA_SUBSIDIARY = "kleaSubsidiary",
}

const entitiesCountryCodes = [
  "BA", // Bosnia and Herzegovina
  "BE", // Belgium
  "BG", // Bulgaria
  "BR", // Brazil
  "CA", // Canada
  "CZ", // Czech Republic
  "DE", // Germany
  "ES", // Spain
  "FI", // Finland
  "FR", // France
  "GB", // United Kingdom
  "GR", // Greece
  "HU", // Hungary
  "IN", // India
  "IT", // Italy
  "NL", // Netherlands
  "PL", // Poland
  "PT", // Portugal
  "SG", // Singapore
  "ZA", // South Africa
  "US", // United states
] as CountryCode[]

export const ENTITIES_COUNTRIES = getCountries(entitiesCountryCodes).sort((a, b) =>
  a.name > b.name ? 1 : -1,
)

export const PAYROLL_CUT_OFF_DAYS = ["10", "15", "20"]
export const PAYROLL_CUT_OFF_DAY_FORMATTED = PAYROLL_CUT_OFF_DAYS.map(value => {
  return { label: `${getOrdinalSuffixOfNumber(Number(value))} of the month`, value }
})

export const AUTO_HIDE_DURATION = 2000
